import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { GridCellType } from "../../common/enums/GridCellType";
import { SystemBalanceTypeEnum } from "../../common/enums/SystemBalanceTypeEnum";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";
import { AccessPermission, IAccessPermission } from "../../common/models/AccessPermission";
import { IBaseGridModel } from "../../common/models/IBaseGridModel";
import * as DRCX from "../../common/enums/DRCXEnums";
import { ISummaryListingDataModel, ISummaryListingSortParams } from "./BaseModels";
import { AttributeSchemaTypeEnum, IAttribute } from "../attribute-data-service/Models";
import { format } from "date-fns";

export interface IPolledDevicesGridRestQueryParams {
    configurationID?: number;
    correlationID?: string;
}

export interface IPolledDevicesModel extends ISummaryListingDataModel {
    isSystemBalanceGroup?: boolean;
    gridData?: IPolledDevicesGridModel;
}

export class PolledDevicesModel implements IPolledDevicesModel {
    public configurationID?: number;
    public isSystemBalanceGroup?: boolean;
    public userPermissions?: Array<AccessPermission>;
    public gridData?: IPolledDevicesGridModel;

    constructor(model?: IPolledDevicesModel) {
        if (model) {
            this.configurationID = model.configurationID;
            this.isSystemBalanceGroup = model.isSystemBalanceGroup;
            this.userPermissions = model.userPermissions?.map(
                (permission: IAccessPermission): AccessPermission => new AccessPermission(permission)
            );
            this.gridData = model.gridData;
        }
    }
}

export interface IPolledDeviceSectionsModel extends ISummaryListingDataModel {
    isSystemBalanceGroup?: boolean;
    gridData?: IPolledDevicesGridModel[];
    deviceCount?: number;
    sectionCount?: number;
    groupByAttributes?: IAttribute[]
}

export class PolledDeviceSectionsModel implements IPolledDeviceSectionsModel {
    public configurationID?: number;
    public isSystemBalanceGroup?: boolean;
    public userPermissions?: Array<AccessPermission>;
    public gridData?: IPolledDevicesGridModel[];
    public deviceCount?: number;
    public sectionCount?: number | undefined;
    public groupByAttributes?: IAttribute[]    

    constructor(model?: IPolledDeviceSectionsModel) {
        if (model) {
            this.configurationID = model.configurationID;
            this.isSystemBalanceGroup = model.isSystemBalanceGroup;
            this.userPermissions = model.userPermissions?.map(
                (permission: IAccessPermission): AccessPermission => new AccessPermission(permission)
            );
            this.gridData = model.gridData;
            this.deviceCount = model.deviceCount;
            this.sectionCount = model.sectionCount;
            this.groupByAttributes = model.groupByAttributes;


            this.gridData?.forEach(o => {
                let memoColumnIndex = o.columns.findIndex(v => v.optionalColumn === DRCX.OptionalColumnEnum.Memos);
                let memoTimestampColumnIndex = o.columns.findIndex(v => v.optionalColumn === DRCX.OptionalColumnEnum.MemoTimestamp);
                if (memoColumnIndex !== -1) {

                    let offset = 0;
                    if (o.columns.some(x => x.field === 'hasRecentMemo')) {
                        ++offset;
                    }

                    if (o.columns.some(x => x.field === 'functionIcons')) {
                        ++offset;
                    }

                    memoColumnIndex -= offset;

                    if (memoTimestampColumnIndex !== -1) {
                        memoTimestampColumnIndex -= offset;
                    }

                    o.rows.forEach(row => {
                        if (row.hasRecentMemo && (row.memoText ?? '').length > 0) {
                            row.cells[memoColumnIndex] = {

                            displayText: row.memoText,
                            objectType: eLynxObjectTypeEnum.Device,
                            //objectID?: number;
                            //dataValue?: number;
                            //displayTimeframe?: TimeframeTypeEnum;
                            //timestamp?: string;
                            inAlarm: false,
                            //backgroundColor: string;
                            //inStaleDataAlarm: boolean;
                            staleDataColor: '',
                            optionalColumn: DRCX.OptionalColumnEnum.Memos,
                            // This should go away later and GridCellType should be used in the UI and WebAPI. The UI must be changed first.
                            isAttributeCell: false
                            //gridCellType?: GridCellType;


                            } as IPolledDevicesGridCell;

                            if (memoTimestampColumnIndex !== -1) {
                            row.cells[memoTimestampColumnIndex] = {

                                displayText: format(new Date(row.memoTimestamp), "P pp"),
                                objectType: eLynxObjectTypeEnum.Device,
                                //objectID?: number;
                                //dataValue?: number;
                                //displayTimeframe?: TimeframeTypeEnum;
                                //timestamp?: string;
                                inAlarm: false,
                                //backgroundColor: string;
                                //inStaleDataAlarm: boolean;
                                staleDataColor: '',
                                optionalColumn: DRCX.OptionalColumnEnum.MemoTimestamp,
                                // This should go away later and GridCellType should be used in the UI and WebAPI. The UI must be changed first.
                                isAttributeCell: false
                                //gridCellType?: GridCellType;


                            } as IPolledDevicesGridCell

                            }
                        }
                    });
                }
            });

            
        }
    }
}


export interface IPolledDevicesGridModel extends IBaseGridModel<IPolledDevicesGridRow> { }

export interface IPolledDevicesGridRow {
    deviceID: number;
    deviceName: string;
    systemBalanceType: SystemBalanceTypeEnum;
    hasTagThreads: boolean;
    hasCommError: boolean;
    hasRecentMemo: boolean;
    hasArchives: boolean;
    hasDeviceTrending: boolean;
    hasLiveData: boolean;
    hasMarketingReport: boolean;
    hasPlungerLiftRunStatistics: boolean;
    hasTankGaugeSheet: boolean;
    hasDynacardView: boolean;
    hasIssuesAndActions: boolean;
    memoText: string;
    memoTimestamp: string;
    memoID: number | undefined;
    memoCreatedBy: string;
    alarmStatus: number;
    order: number;
    active: boolean;
    cells: IPolledDevicesGridCell[];
    latitude: number | undefined;
    longitude: number | undefined;
    hasMemoModify: boolean;
}

export interface IPolledDevicesGridCell {
    displayText: string;
    objectType: eLynxObjectTypeEnum;
    objectID?: number;
    dataValue?: number;
    displayTimeframe?: TimeframeTypeEnum;
    timestamp?: string;
    inAlarm: boolean;
    backgroundColor: string;
    inStaleDataAlarm: boolean;
    staleDataColor: string;
    optionalColumn?: DRCX.OptionalColumnEnum;
    // This should go away later and GridCellType should be used in the UI and WebAPI. The UI must be changed first.
    isAttributeCell: boolean;
    gridCellType?: GridCellType;
}

export interface IPolledDevicesSortParams extends ISummaryListingSortParams {
    sortBySystemBalanceType: boolean;
    sortByDevicesInAlarmFirst: boolean;
    //sortByRecentMemo: boolean;
    //sortAscending: boolean;
    //sortColumnIndex: number;
}

export interface IGroupByAttribute {
//    name: string;
    value: string;
    attrType: AttributeSchemaTypeEnum;
    devices: number[]
}
